<template>
  <div class="product-container">
    <div class="filter-container">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="商品名称">
          <el-input
              v-model="filterForm.name"
              placeholder="请输入商品名称"
              clearable
              @clear="handleFilter"
              @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item label="商品分类">
          <el-select
              v-model="filterForm.category"
              placeholder="请选择分类"
              clearable
              @change="handleFilter"
          >
            <el-option
                v-for="item in categoryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="商品状态">
          <el-select
              v-model="filterForm.status"
              placeholder="请选择状态"
              clearable
              @change="handleFilter"
          >
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="operation-container">
      <el-button type="primary" @click="handleCreate">
        <i class="el-icon-plus"></i> 新增商品
      </el-button>
      <el-button type="success" @click="handleImport">
        <i class="el-icon-upload2"></i> 导入
      </el-button>
      <el-button type="warning" @click="handleExport">
        <i class="el-icon-download"></i> 导出
      </el-button>
      <el-button type="danger" @click="handleBatchDelete" :disabled="!selectedItems.length">
        <i class="el-icon-delete"></i> 批量删除
      </el-button>
    </div>

    <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="loading"
    >
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="name" label="商品名称" min-width="150"></el-table-column>
      <el-table-column prop="category" label="分类" width="120" align="center">
        <template slot-scope="scope">
          {{ formatCategory(scope.row.category) }}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格(元)" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.price.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="stock" label="库存" width="100" align="center"></el-table-column>
      <el-table-column prop="sales" label="销量" width="100" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">
            {{ formatStatus(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="180" align="center">
        <template slot-scope="scope">
          {{ formatDate(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
          >编辑</el-button>
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
      ></el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="商品名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品分类" prop="category">
          <el-select v-model="form.category" placeholder="请选择分类">
            <el-option
                v-for="item in categoryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品价格" prop="price">
          <el-input-number
              v-model="form.price"
              :min="0"
              :precision="2"
              :step="0.1"
              controls-position="right"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="商品库存" prop="stock">
          <el-input-number v-model="form.stock" :min="0" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="商品状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品图片">
          <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgDialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="商品描述" prop="description">
          <el-input
              type="textarea"
              :rows="3"
              v-model="form.description"
              placeholder="请输入商品描述"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 导入对话框 -->
    <el-dialog title="导入商品" :visible.sync="importDialogVisible" width="40%">
      <div class="import-container">
        <el-upload
            class="upload-demo"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :before-upload="beforeUpload"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :show-file-list="false"
            accept=".xlsx, .xls"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过5MB</div>
        </el-upload>
        <div class="download-template">
          <el-button type="text" @click="downloadTemplate">下载导入模板</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 模拟数据生成函数
function generateMockData(count) {
  const categories = [1, 2, 3, 4]
  const statuses = [0, 1]
  const mockData = []

  for (let i = 1; i <= count; i++) {
    mockData.push({
      id: 10000 + i,
      name: `商品${i}`,
      category: categories[Math.floor(Math.random() * categories.length)],
      price: parseFloat((Math.random() * 1000).toFixed(2)),
      stock: Math.floor(Math.random() * 1000),
      sales: Math.floor(Math.random() * 500),
      status: statuses[Math.floor(Math.random() * statuses.length)],
      description: `这是商品${i}的描述信息`,
      createdAt: new Date(Date.now() - Math.floor(Math.random() * 30 * 24 * 60 * 60 * 1000)),
      image: `https://picsum.photos/200/200?random=${i}`
    })
  }

  return mockData
}

export default {
  name: 'ProductView',
  data() {
    return {
      filterForm: {
        name: '',
        category: '',
        status: ''
      },
      categoryOptions: [
        { value: 1, label: '电子产品' },
        { value: 2, label: '家居用品' },
        { value: 3, label: '服装鞋帽' },
        { value: 4, label: '食品饮料' }
      ],
      statusOptions: [
        { value: 1, label: '上架' },
        { value: 0, label: '下架' }
      ],
      tableData: [],
      selectedItems: [],
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增商品',
      form: {
        id: '',
        name: '',
        category: '',
        price: 0,
        stock: 0,
        status: 1,
        description: '',
        image: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择商品分类', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '请输入商品库存', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择商品状态', trigger: 'change' }
        ]
      },
      imgDialogVisible: false,
      dialogImageUrl: '',
      importDialogVisible: false,
      currentEditIndex: -1
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      // 模拟API请求延迟
      setTimeout(() => {
        const allData = generateMockData(85)
        // 模拟筛选
        let filteredData = [...allData]

        if (this.filterForm.name) {
          filteredData = filteredData.filter(item =>
              item.name.includes(this.filterForm.name)
          )
        }

        if (this.filterForm.category !== '') {
          filteredData = filteredData.filter(item =>
              item.category === this.filterForm.category
          )
        }

        if (this.filterForm.status !== '') {
          filteredData = filteredData.filter(item =>
              item.status === this.filterForm.status
          )
        }

        this.pagination.total = filteredData.length
        const start = (this.pagination.currentPage - 1) * this.pagination.pageSize
        const end = start + this.pagination.pageSize
        this.tableData = filteredData.slice(start, end)
        this.loading = false
      }, 500)
    },
    handleFilter() {
      this.pagination.currentPage = 1
      this.fetchData()
    },
    resetFilter() {
      this.filterForm = {
        name: '',
        category: '',
        status: ''
      }
      this.handleFilter()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },
    handleSelectionChange(val) {
      this.selectedItems = val
    },
    handleCreate() {
      this.dialogTitle = '新增商品'
      this.form = {
        id: '',
        name: '',
        category: '',
        price: 0,
        stock: 0,
        status: 1,
        description: '',
        image: ''
      }
      this.currentEditIndex = -1
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleEdit(index, row) {
      this.dialogTitle = '编辑商品'
      this.form = { ...row }
      this.currentEditIndex = index
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleDelete(index) {
      this.$confirm('确认删除该商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 模拟删除
        this.tableData.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleBatchDelete() {
      if (this.selectedItems.length === 0) {
        this.$message.warning('请至少选择一项')
        return
      }

      this.$confirm(`确认删除选中的 ${this.selectedItems.length} 项商品吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 模拟批量删除
        const ids = this.selectedItems.map(item => item.id)
        this.tableData = this.tableData.filter(item => !ids.includes(item.id))
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.selectedItems = []
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 模拟提交
          if (this.currentEditIndex === -1) {
            // 新增
            const newId = Math.max(...this.tableData.map(item => item.id)) + 1
            this.form.id = newId
            this.form.createdAt = new Date()
            this.tableData.unshift({ ...this.form })
          } else {
            // 编辑
            Object.assign(this.tableData[this.currentEditIndex], this.form)
          }

          this.$message.success('操作成功')
          this.dialogVisible = false
          this.fetchData()
        } else {
          return false
        }
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.imgDialogVisible = true
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handleImport() {
      this.importDialogVisible = true
    },
    handleExport() {
      // 模拟导出
      this.$message.success('导出功能已触发，实际项目中会导出当前筛选条件的数据')
      // 这里可以添加实际导出逻辑，如使用 xlsx 库导出数据
      // this.exportToExcel()
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          file.type === 'application/vnd.ms-excel'

      if (!isExcel) {
        this.$message.error('只能上传Excel文件!')
      }
      if (!isLt5M) {
        this.$message.error('文件大小不能超过5MB!')
      }

      return isExcel && isLt5M
    },
    // handleUploadSuccess(response, file, fileList) {
    handleUploadSuccess(){
      this.$message.success('文件上传成功')
      // 模拟导入数据处理
      setTimeout(() => {
        const newData = generateMockData(10) // 模拟导入10条新数据
        this.tableData = [...newData, ...this.tableData]
        this.pagination.total += newData.length
        this.importDialogVisible = false
        this.$message.success('成功导入10条商品数据')
      }, 1500)
    },
    // handleUploadError(err, file, fileList) {
    handleUploadError(err){
      this.$message.error('文件上传失败')
      console.error(err)
    },
    downloadTemplate() {
      // 模拟下载模板
      this.$message.success('下载模板功能已触发，实际项目中会下载Excel模板文件')
      // 这里可以添加实际下载逻辑
    },
    formatCategory(category) {
      const categoryMap = {
        1: '电子产品',
        2: '家居用品',
        3: '服装鞋帽',
        4: '食品饮料'
      }
      return categoryMap[category] || '未知分类'
    },
    formatStatus(status) {
      return status === 1 ? '上架' : '下架'
    },
    formatDate(date) {
      return new Date(date).toLocaleString()
    }
  }
}
</script>

<style scoped>
.product-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.filter-container {
  margin-bottom: 20px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
}

.operation-container {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
  position: sticky;
  bottom: 20px;
  background-color: #fff;
  padding: 10px 0;
  z-index: 10;
}

.import-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.download-template {
  margin-top: 20px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .filter-form {
    flex-direction: column;
  }

  .filter-container .el-form-item {
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }

  .operation-container .el-button {
    margin-bottom: 10px;
  }
}
</style>